import { supabase } from "../lib/supabase";

// Billable conversions for the QuickBooks invoice export (DEV-2600), from the
// support-only RPC of migrations 099 and 104. p_start and p_end are
// "YYYY-MM-DD" UTC days, both included.

// PostgREST's row cap per response, and the RPC's own maximum p_limit.
export const PAGE_SIZE = 1000;

// The longest range the RPC accepts, in days with both ends included (099).
export const MAX_RANGE_DAYS = 366;

function client() {
  if (!supabase) {
    throw new Error("Supabase client is not initialized");
  }
  return supabase;
}

// Keyset paging: each page resumes after the previous page's last row, so a
// row is never read twice (105 pages by advertiser and id; the verdict is
// still sent for 104, which ordered by it).
// advertiserIds: the advertisers to export, or null for every advertiser (any
// billing method).
export async function fetchBillableConversions(start, end, advertiserIds = null) {
  const out = [];
  let cursor = {};
  for (;;) {
    const { data, error } = await client().rpc("support_billable_conversions_export", {
      p_start: start,
      p_end: end,
      p_limit: PAGE_SIZE,
      // Left out for every advertiser, so the call also matches 099's function
      // while migration 104 is not applied yet.
      ...(advertiserIds === null ? {} : { p_advertiser_ids: advertiserIds }),
      ...cursor,
    });
    if (error) {
      throw new Error("Could not load the billable conversions.");
    }
    const page = data ?? [];
    out.push(...page);
    // Only an empty page ends the export: PostgREST may cap a page below
    // PAGE_SIZE, so a short page is not proof that nothing follows.
    if (page.length === 0) return out;
    const last = page[page.length - 1];
    cursor = {
      p_after_advertiser_id: last.advertiser_id,
      p_after_evaluated_at: last.billing_evaluated_at,
      p_after_id: last.conversion_id,
    };
  }
}
